import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Card, Grid, Typography } from '@mui/material';
import { CarModel } from 'models/StockModel';
import AlbumButton from 'modules/cars/common/AlbumButton';


type PhotoCardProps = {
    car: CarModel,
}

const PhotoCard = ({ car }: PhotoCardProps) => {
    const {t} = useTranslation('cars');

    return (
        <Card sx={{mb: 2}}>
            <Box p={2}>
                <Grid container>
                    <Grid item xs={6}>
                        <Typography variant="h5">{t('photos')}</Typography>
                    </Grid>
                    <Grid
                        item xs={6}
                    >
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                justifyContent: 'flex-end',
                                marginRight: -1,
                            }}
                        >
                            <AlbumButton car={car}/>
                        </Box>
                    </Grid>
                </Grid>
            </Box>
        </Card>
    );
};

export default PhotoCard;
